<template>
    <div class="modal fade" id="faqModal" tabindex="-1" role="dialog" aria-labelledby="faqModalLabel">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h1>Frequently Asked Questions</h1>
                </div>
                <div class="modal-body">
                    <label class="question" style="padding-top: 10px;">What is Valkyrie Intelligence?</label>
                    <p class="answer">
                        Valkyrie Intelligence is an advanced threat intelligence service that lets you identify targeted attacks and potential
                        threats associated with your organization.
                    </p>
                    <br>
                    <label class="question">Why use Valkyrie Intelligence?</label>
                    <p class="answer">
                        Valkyrie Intelligence provides instant notifications and actionable threat ingelligence both for targeted attacks and
                        potential threats. Therefore it enables real time tracking of targeted threads and responding to incidents on time.
                    </p>
                    <br>
                    <label class="question">How does Valkyrie Intelligence collects data?</label>
                    <p class="answer">
                        Valkyrie Intelligence actively collects the raw information from the web and dark web by using its own sources and turns
                        them into actionable insights.
                    </p>
                    <br>
                    <label class="question">What kind of feeds do Valkyrie Intelligence have?</label>
                    <p class="answer">
                        Valkyrie Intelligence provides more than 60 different feeds for files, urls, domains and IPs that covers malware,
                        potentially unwanted applications, phishing, compromised domains and much more. For the complete list please contact us.
                    </p>
                    <br>
                    <label class="question">Does Valkyrie Intelligence have API/SDK?</label>
                    <p class="answer">
                        Valkyrie Intelligence has both API and SDK for you to integrate its intelligence output to your existing system.
                        For more information please vsit our API/SDK page.
                    </p>
                    <br>
                    <label class="question">Does Valkyrie Intelligence encrypt data related with customers?</label>
                    <p class="answer">
                        Valkyrie Intelligence uses the highest standard of encryption and professional security analysts to ensure the privacy
                        of all data collected by the system.
                    </p>
                    <br>
                    <label class="question">Does Valkyrie Intelligence provides incident response?</label>
                    <p class="answer">
                        Valkyrie Intelligence is fully integrated with other security solutions of Comodo for responding to incidents and prevent threats.
                    </p>
                    <br>
                    <label class="question">Do you partner with new data providers?</label>
                    <p class="answer">
                        We're always looking for data partners. If you have URL/Domain/IP data and would like to partner with us, please reach out using our contact page.
                    </p>
                    <label class="question">Helpdesk</label>
                    <p class="answer">
                        To get support or to report an error, please contact.
                    </p>
                    <p class="answer" style="font-style: italic; font-size: 13px">
                        vtisupport@comodo.com
                    </p>
                    <div style="position:relative; height: 50px">
                        <button id="close-button" class="grow" @click="hideModal"> Close </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "faq",
        methods: {
            showModal(){
                $('#faqModal').modal('show');
            },
            hideModal(){
                $('#faqModal').modal('hide');
            }
        },
        mounted() {
            $('#faqModal').modal({show: false});
        }
    }
</script>

<style scoped>

    #close-button {
        background-color: rgba(255, 0, 67, 1);
        border:none;
        height: 50px;
        width: 100px;
        color: white;
        padding: 0 15px;
        font-family: 'Digital-Serial-Bold' !important;
        position: absolute;
        right: 1%;
        font-size: large;
    }

    .question{
        color: limegreen;
        font-size: x-large;
    }

    .modal-dialog {
        height: 90% !important;
    }

    .modal-content {
        height: 100% !important;
        background-color: white !important;
        overflow: hidden;
    }

    .modal-body{
        overflow-y: scroll;
        max-height: 88% !important;
    }

    h1{
        color: limegreen;
        font-family: 'Digital-Serial-Bold' !important;
    }

    p, label{
        font-family: 'Digital-Serial-Bold' !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/modals/FaqModal.vue